// import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
// import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute, Router } from '@angular/router';
// import { SidenavService } from 'src/app/services/sidenav.service';
// import { AppStateProvider } from 'src/app/services/app-state.provider';
// import { Subscription } from 'rxjs';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
// import { EmergencyinfoService } from 'src/app/services/emergencyinfo.service';
// import { AddemergencyinfoService } from 'src/app/services/addemergencyinfo.service';
// import { DomSanitizer } from '@angular/platform-browser';
// import { Emergencyinfo } from 'src/app/model/emergencyinfo.model';

// @Component({
//   selector: 'app-create-emergency-info',
//   templateUrl: './create-emergency-info.component.html',
//   styleUrls: ['./create-emergency-info.component.scss']
// })
// export class CreateEmergencyInfoComponent implements OnInit, OnDestroy {

//   @ViewChild('uploadImages') uploadImages: ElementRef;

//   public emergencyinfo = new Emergencyinfo();
//   private subscriptions = new Subscription();

//   headline: string;
//   description: string;
//   prakList: any = [];
//   public formData: any;
//   uploadData: any;
//   imageName: any;
//   images = [];
//   photoData: any = {};
//   imageTobeUpload: any;

//   myForm = new FormGroup({
//     ParkId: new FormControl(),
//     emergencyInfoNotes: new FormArray([]),
//     createdBy: new FormControl(),
//     isActive: new FormControl(),
//   });
//   convertedFileForUpload: any;
//   fileArray = [];

//   constructor(
//     private formBuilder: FormBuilder,
//     private router: Router,
//     private sideNavService: SidenavService,
//     private appStateSrv: AppStateProvider,
//     private modalService: NgbModal,
//     private emergencyinfoService: EmergencyinfoService,
//     private sanitizer: DomSanitizer,
//     private acroute: ActivatedRoute,
//     private addemergencyinfoService: AddemergencyinfoService,
//   ) {
//     this.myForm = this.formBuilder.group({
//       ParkId: '',
//       emergencyInfoNotes: this.formBuilder.array([this.newNotes()]),
//       createdBy: '',
//       isActive: true,
//     });
//   }

//   ngOnInit(): void {
//   }

//   ngOnDestroy(): void {
//   }

//   emergencyInfoNotes(): FormArray {
//     return this.myForm.get('emergencyInfoNotes') as FormArray;
//   }

//   newNotes(): FormGroup {
//     return this.formBuilder.group({
//       headline: ['', Validators.required],
//       description: ['', Validators.required],
//       emergencyInfoPhotos: [''],
//     });
//   }

//   addMore(): void {
//     this.emergencyInfoNotes().push(this.newNotes());
//   }

//   removeBlock(i: number) {
//     this.emergencyInfoNotes().removeAt(i);
//   }

//   onSubmit(): void {

//     this.uploadData = new FormData();

//     this.myForm.patchValue({
//       CreatedBy: localStorage.getItem('claAdminId'),
//       IsActive: true,
//     });

//     const uploadData = new FormData();
//     for (let i = 0; i <= this.myForm.value.emergencyInfoNotes.length - 1; i++) {
//       uploadData.append(
//         'emergencyInfoNotes[' + i + '].headline',
//         this.myForm.value.emergencyInfoNotes[i].headline
//       );
//       uploadData.append(
//         'emergencyInfoNotes[' + i + '].description',
//         this.myForm.value.emergencyInfoNotes[i].description
//       );
//       uploadData.append(
//         'emergencyInfoNotes[' + i + '].emergencyInfoPhotos',
//         this.fileArray[i]
//       );
//     }
//     const parkID = localStorage.getItem('parkId');
//     uploadData.append('ParkId', parkID);
//     uploadData.append('CreatedBy', localStorage.getItem('claAdminId'));
//     uploadData.append('IsActive', 'true');

//     console.log(uploadData);

//     if (this.myForm.valid) {
//       this.addemergencyinfoService
//         .createEmergencyInfo(uploadData)
//         .subscribe((res) => {
//           this.fileArray = [];
//           this.router.navigate(['/view-emergency-info/']);
//         });
//     } else {
//       this.myForm.markAllAsTouched();
//     }
//   }

//   convertFileToBase64(file) {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => resolve(reader.result);
//       reader.onerror = error => reject(error);
//       reader.readAsDataURL(file);
//     });
//   }

//   base64ToFile(base64String, filename) {
//     let arr = base64String.split(','),
//       mime = arr[0].match(/:(.*?);/)[1],
//       bstr = atob(arr[1]),
//       n = bstr.length,
//       u8arr = new Uint8Array(n);

//     while (n--) {
//       u8arr[n] = bstr.charCodeAt(n);
//     }

//     return new File([u8arr], filename, { type: mime });
//   }

//   onFileChange(event) {
//     this.convertedFileForUpload = '';
//     const file = event.target.files[0];

//     var filesAmount = event.target.files.length;
//     for (let i = 0; i < filesAmount; i++) {
//       var reader = new FileReader();
//       reader.readAsDataURL(event.target.files[i]);
//       reader.onload = (innerEvent: any) => {
//         this.images.push({
//           imgBase64: innerEvent.target.result,
//           imgFile: event.target.files[i],
//         });
//       };
//     }

//     this.convertFileToBase64(file)
//       .then(base64String => {
//         const convertedFile = this.base64ToFile(base64String, file.name);
//         this.convertedFileForUpload = convertedFile;
//         this.fileArray.push(this.convertedFileForUpload);
//         console.log(this.fileArray);
//       });
//   }

//   //api calls
//   getParkDetails() {
//     this.emergencyinfoService.getParkByCLAId().subscribe((res) => {
//       if (res.isValid) {
//         this.prakList = res.list;
//       }
//     });
//   }

//   gotoViewPage() {
//     this.router.navigate(['/view-emergency-info/']);
//   }

//   removeImage(i: any) {
//     console.log(i);
//     this.images.splice(i, 1);
//     this.imageName = '';
//   }

// }

import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { EmergencyinfoService } from 'src/app/services/emergencyinfo.service';
import { AddemergencyinfoService } from 'src/app/services/addemergencyinfo.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Emergencyinfo } from 'src/app/model/emergencyinfo.model';
import { ClassicEditor, Essentials, Bold, Italic, Heading, List, Link, BlockQuote, Table, TableToolbar } from 'ckeditor5';

@Component({
  standalone: false,
  selector: 'app-create-emergency-info',
  templateUrl: './create-emergency-info.component.html',
  styleUrls: ['./create-emergency-info.component.scss']
})
export class CreateEmergencyInfoComponent implements OnInit, OnDestroy {

  @ViewChildren('uploadImage') uploadImages: QueryList<ElementRef>;

  public emergencyinfo = new Emergencyinfo();
  private subscriptions = new Subscription();
  public Editor = ClassicEditor;
  headline: string;
  description: string;
  prakList: any = [];
  public formData: any;
  uploadData: any;
  imageNames: string[] = [];
  images: any[] = []; // Updated to be a 2D array
  photoData: any = {};
  imageTobeUpload: any;
  infoList = [];

  myForm = new FormGroup({
    ParkId: new FormControl(),
    emergencyInfoRequest: new FormArray([]),
    createdBy: new FormControl(),
    isActive: new FormControl(),
    emergencyInfoId: new FormControl(),
  });
  convertedFileForUpload: any;
  fileArray: any[] = [];

  ckconfig = {
    plugins: [ Essentials, Bold, Italic, Heading, List, Link, BlockQuote, Table, TableToolbar ],
    toolbar: [
      'heading', '|',
      'bold', 'italic', '|',
      'numberedList', 'bulletedList', '|',
      'undo', 'redo', '|',
      'link', '|',
      'blockQuote', '|',
      'insertTable', '|'
    ],
    table: {
      contentToolbar: [
        'tableColumn', 'tableRow', 'mergeTableCells'
      ]
    }
  }
  parkID: string;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private emergencyinfoService: EmergencyinfoService,
    private sanitizer: DomSanitizer,
    private addemergencyinfoService: AddemergencyinfoService,
  ) {

  }

  ngOnInit(): void {
    this.getSavedListEmergencyInfo();
    if (this.infoList.length > 0) {
      this.myForm = this.formBuilder.group({
        ParkId: '',
        // emergencyInfoRequest: this.formBuilder.array([this.newNotes()]),
        emergencyInfoRequest: this.formBuilder.array([]),
        createdBy: '',
        isActive: true,
        emergencyInfoId: ''
      });
    } else {
      this.myForm = this.formBuilder.group({
        ParkId: '',
        emergencyInfoRequest: this.formBuilder.array([this.newNotes()]),
        // emergencyInfoRequest: this.formBuilder.array([]),
        createdBy: '',
        isActive: true,
        emergencyInfoId: ''
      });
    }
    this.parkID = localStorage.getItem('parkId');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  emergencyInfoRequest(): FormArray {
    return this.myForm.get('emergencyInfoRequest') as FormArray;
  }

  newNotes(
    header?: string,
    description?: string,
    emergencyInfoId?: string
  ): FormGroup {
    return this.formBuilder.group({
      header: [header ? header : '', Validators.required],
      description: [description ? description : '', Validators.required],
      emergencyInfoId: [emergencyInfoId ? emergencyInfoId : ''],
      // image: [''],
      // createdBy: localStorage.getItem('claAdminId'),
    });
  }

  addMore(): void {
    this.emergencyInfoRequest().push(this.newNotes());
    this.images.push([]);
    this.imageNames.push('');
  }

  removeBlock(i: number) {
    this.emergencyInfoRequest().removeAt(i);
    this.images.splice(i, 1);
    this.imageNames.splice(i, 1);
  }

  onSubmit(): void {
    this.uploadData = new FormData();

    // this.myForm.patchValue({
    //   CreatedBy: localStorage.getItem('claAdminId'),
    //   IsActive: true,
    // });

    for (let i = 0; i < this.myForm.value.emergencyInfoRequest.length; i++) {
      this.uploadData.append('emergencyInfoRequest[' + i + '].header', this.myForm.value.emergencyInfoRequest[i].header);
      this.uploadData.append('emergencyInfoRequest[' + i + '].description', this.myForm.value.emergencyInfoRequest[i].description);
      if (this.fileArray[i]) {
        this.uploadData.append('emergencyInfoRequest[' + i + '].image', this.fileArray[i]);
      }
      this.uploadData.append('emergencyInfoRequest[' + i + '].createdBy', localStorage.getItem('claAdminId'));
      this.uploadData.append('emergencyInfoRequest[' + i + '].emergencyInfoId', this.myForm.value.emergencyInfoRequest[i].emergencyInfoId);
      this.uploadData.append('emergencyInfoRequest[' + i + '].parkId', this.parkID);
    }

    const parkID = localStorage.getItem('parkId');
    // this.uploadData.append('ParkId', parkID);
    // this.uploadData.append('CreatedBy', localStorage.getItem('claAdminId'));
    // this.uploadData.append('IsActive', 'true');

    if (this.myForm.valid) {
      this.addemergencyinfoService.createEmergencyInfo(this.uploadData).subscribe((res) => {
        this.fileArray = [];
        // window.location.reload();
        // this.router.navigate(['/view-emergency-info/']);
      });
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  convertFileToBase64(file): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }

  base64ToFile(base64String, filename): File {
    let arr = base64String.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  triggerFileInputClick(fileInput): void {
    fileInput.click();
  }

  onFileChange(event, index): void {
    console.log(index);
    const file = event.target.files[0];

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (innerEvent: any) => {
      if (!this.images[index]) {
        this.images[index] = [];
      }
      // this.images[index].push({
      //   imgBase64: innerEvent.target.result,
      //   imgFile: file,
      // });

      if (this.images[index].length > 0) {
        // Replace the image if it already exists
        this.images[index][0] = {
          imgBase64: innerEvent.target.result,
          imgFile: file,
        };
      } else {
        // Add a new image if it doesn't exist
        this.images[index].push({
          imgBase64: innerEvent.target.result,
          imgFile: file,
        });
      }
    };

    console.log(this.images);

    this.convertFileToBase64(file).then(base64String => {
      const convertedFile = this.base64ToFile(base64String, file.name);
      this.fileArray[index] = convertedFile;
      this.imageNames[index] = file.name;

      console.log(this.fileArray);
    });
  }

  removeImage(noteIndex: number, imageIndex: number): void {
    this.images[noteIndex].splice(imageIndex, 1);
    if (this.images[noteIndex].length === 0) {
      this.imageNames[noteIndex] = '';
      delete this.fileArray[noteIndex];
    }
  }

  getSavedListEmergencyInfo() {
    this.images = [];
    const parkID = localStorage.getItem('parkId');
    this.emergencyinfoService.getEmergencyInfoList(parkID).subscribe((res) => {
      this.infoList = res?.list;

      if (this.infoList.length > 0) {
        this.myForm = this.formBuilder.group({
          ParkId: '',
          // emergencyInfoRequest: this.formBuilder.array([this.newNotes()]),
          emergencyInfoRequest: this.formBuilder.array([]),
          createdBy: '',
          isActive: true,
          emergencyInfoId: ''
        });
      } else {
        this.myForm = this.formBuilder.group({
          ParkId: '',
          emergencyInfoRequest: this.formBuilder.array([this.newNotes()]),
          // emergencyInfoRequest: this.formBuilder.array([]),
          createdBy: '',
          isActive: true,
          emergencyInfoId: ''
        });
      }

      for (let i = 0; i <= this.infoList?.length - 1; i++) {
        this.emergencyInfoRequest().push(
          this.newNotes(
            this.infoList[i]?.header,
            this.infoList[i]?.description,
            this.infoList[i]?.emergencyInfoId
          )
        );
        console.log(this.infoList[i]?.image);
        console.log(this.images);

        if (this.infoList[i]?.image != null) {
          if (!this.images[i]) {
            this.images[i] = [];
          }
          if (this.images[i].length > 0) {
            // Replace the image if it already exists
            this.images[i][0] = {
              imgBase64: this.infoList[i]?.image,
              imgFile: '',
            };
          } else {
            // Add a new image if it doesn't exist
            this.images[i].push({
              imgBase64: this.infoList[i]?.image,
              imgFile: '',
            });
          }
          const fileName = this.infoList[i]?.image.split('?')[0];
          this.convertImageUrlToFile(this.infoList[i]?.image, fileName)
            .then(file => {
              this.fileArray[i] = file;
              this.imageNames[i] = fileName;
              console.log(file); // The File object representing the image
            })
            .catch(error => {
              console.error('Error:', error);
            });
        }
      }
      console.log(this.fileArray);
    });
  }

  async convertImageUrlToFile(imageUrl, fileName) {
    try {
      // Fetch the image
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();

      // Create a File object from the Blob
      const file = new File([blob], fileName, { type: blob.type });

      return file;
    } catch (error) {
      console.error('Error converting image URL to file:', error);
    }
  }
}
